import { isEmpty } from 'underscore'
import { parseAmount } from '../validations/parse-amount'

/**
 * variation, amount numérico, password,
 * rama nueva cuenta vs `cashout_account_id`, phone solo si viene, documents opcional.
 * @param {Record<string, unknown>} requestData
 * @returns {FormData}
 */
export const buildCashoutFormData = (requestData) => {
  const amount = parseAmount(requestData.amount)
  if (!Number.isFinite(amount)) {
    throw new Error('El monto no es válido')
  }

  const formData = new FormData()
  formData.append('variation', requestData.variation)
  formData.append('amount', String(amount))
  formData.append('password', requestData.password)

  if (requestData.cashout_account_id == null && isEmpty(requestData.cashout_account_id)) {
    formData.append('name', requestData.name)
    formData.append('last_name', requestData.last_name)
    formData.append('bank', requestData.bank)
    formData.append('bank_code', requestData.bank_code)
    formData.append('method', requestData.method)
    formData.append('account', requestData.account)
    if (requestData.phone !== null && requestData.phone !== '') {
      formData.append('phone', requestData.phone)
    }
  } else {
    formData.append('cashout_account_id', requestData.cashout_account_id)
  }

  if (
    Object.prototype.hasOwnProperty.call(requestData, 'documents') &&
    requestData.documents !== undefined
  ) {
    const { documents } = requestData
    if (documents.bank_statement != null) {
      formData.append('documents[bank_statement]', documents.bank_statement)
    }
    if (documents.card != null) {
      formData.append('documents[card]', documents.card)
    }
    if (documents.csf != null) {
      formData.append('documents[csf]', documents.csf)
    }
  }

  return formData
}
